<template>
  <div id="sidebar-plot-detail-wrapper" class="vs-con-loading__container">
    <div v-if="plot" id="sidebar-plot-detail">
      <div class="h-full pt-4 sidebar-plot-detail__container">
        <div>
          <div id="sidebar-plot-detail-upper-body">
            <vs-row>
              <vs-col
                vs-offset="10"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2"
              >
                <feather-icon
                  icon="XIcon"
                  @click.stop="cleanUpPlotDetail"
                  class="cursor-pointer"
                ></feather-icon>
              </vs-col>
            </vs-row>

            <vs-row
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              class="mb-2 ml-2"
            >
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2"
              >
                <img :src="plotIcon" style="height: 2rem" />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
                vs-w="10"
              >
                <h6 class="pr-6">{{ plotName }}</h6>
              </vs-col>
            </vs-row>

            <div v-if="plotPictures" class="ml-4 mr-4">
              <swiper
                :options="swiperOption"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :key="$vs.rtl"
              >
                <swiper-slide v-for="picture in plotPictures" :key="picture.id">
                  <picture-view :picture="picture"></picture-view>
                </swiper-slide>
                <div
                  v-if="plotPictures.length > 1"
                  class="swiper-button-prev swiper-button-white"
                  slot="button-prev"
                ></div>
                <div
                  v-if="plotPictures.length > 1"
                  class="swiper-button-next swiper-button-white"
                  slot="button-next"
                ></div>
              </swiper>
            </div>

            <vs-divider class="mb-0" />
          </div>

          <component
            :is="scrollbarTag"
            class="sidebar-plot-detail-scroll-area pt-4 pb-6"
            :style="{ height: plotDetailLowerBodyHeight }"
            :settings="settings"
            :key="$vs.rtl"
          >
            <vs-row vs-type="flex" class="mt-1 mr-4 mb-4">
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <feather-icon
                    icon="InfoIcon"
                    svgClasses="h-5 w-5 mb-1 ml-4 stroke-current feather-icon-color"
                  ></feather-icon>
                </div>
                <div class="leading-none ml-2">
                  <h6 class="font-semibold">プロット情報</h6>
                </div>
              </div>
            </vs-row>

            <div class="flex items-center justify-between ml-4 mr-4">
              <div class="flex items-center">
                <div class="leading-none">
                  <span>プロット種別</span>
                </div>
              </div>
              <div class="leading-none">
                <span class="font-semibold">{{ plotCategoryName }}</span>
              </div>
            </div>

            <div class="flex items-center justify-between ml-4 mr-4 mt-4">
              <div class="flex items-center">
                <div class="leading-none">
                  <span>表示開始日時</span>
                </div>
              </div>
              <div class="leading-none">
                <div class="font-semibold">
                  <span v-if="plotStartDate">{{
                    plotStartDate | toYMDHM
                  }}</span>
                  <span v-else>-</span>
                </div>
              </div>
            </div>

            <div class="flex items-center justify-between ml-4 mr-4 mt-4">
              <div class="flex items-center">
                <div class="leading-none">
                  <span>表示終了日時</span>
                </div>
              </div>
              <div class="leading-none">
                <div class="font-semibold">
                  <span v-if="plotEndDate">{{ plotEndDate | toYMDHM }}</span>
                  <span v-else>-</span>
                </div>
              </div>
            </div>

            <div
              v-show="isConstruction"
              class="flex items-center justify-between ml-4 mr-4 mt-4"
            >
              <div class="flex items-center">
                <div class="leading-none">
                  <span>事業者</span>
                </div>
              </div>
              <div class="leading-none">
                <div class="font-semibold">
                  <span v-if="plotInstaller">{{ plotInstaller }}</span>
                  <span v-else>-</span>
                </div>
              </div>
            </div>

            <div
              v-show="isConstruction"
              class="flex items-center justify-between ml-4 mr-4 mt-4"
            >
              <div class="flex items-center">
                <div class="leading-none">
                  <span>電話番号</span>
                </div>
              </div>
              <div class="leading-none">
                <div class="font-semibold">
                  <span v-if="plotPhoneNumber">{{ plotPhoneNumber }}</span>
                  <span v-else>-</span>
                </div>
              </div>
            </div>

            <div class="ml-4 mr-4 mt-4">
              <div class="mb-4">
                <div class="leading-none">
                  <span>コメント</span>
                </div>
              </div>
              <div class="leading-none">
                <span
                  v-if="plotComment"
                  class="font-semibold plot-comment"
                  v-html="replaceComment(plotComment)"
                />
                <span v-else>-</span>
              </div>
            </div>

            <div class="flex items-center justify-between ml-4 mr-4 mt-4">
              <div class="flex items-center">
                <div class="leading-none">
                  <span>登録者</span>
                </div>
              </div>
              <div class="leading-none">
                <span class="font-semibold">{{ plotRegistrant }}</span>
              </div>
            </div>
          </component>

          <div slot="footer">
            <vs-row
              v-if="!isFreeAccount"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              class="mt-4"
              id="sidebar-plot-detail-footer"
            >
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
              >
                <vs-button @click="onPlotEdit">編集</vs-button>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import PictureView from "../vesselDetail/components/PictureView";
import { PLOT_CHILD_CATEGORY } from "@/config/const";

import { createNamespacedHelpers } from "vuex";

const { mapState, mapActions, mapMutations } =
  createNamespacedHelpers("liveMap");

export default {
  name: "SidebarPlotDetail",
  components: {
    VuePerfectScrollbar,
    swiper,
    swiperSlide,
    PictureView,
  },
  data() {
    return {
      active: true,
      show: false,
      plotIcon: null,
      swiperOption: {
        height: 150,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      defaultValues: {
        num: "0.0",
        chara: "---",
      },
      plotDetailLowerBodyHeight: "300px",
    };
  },
  computed: {
    ...mapState({
      plot: (state) => state.plotDetail,
      PLOT_CHILD_CATEGORY: () => PLOT_CHILD_CATEGORY,
    }),
    rtl: {
      get() {
        return this.$vs.rtl;
      },
      set(val) {
        this.$vs.rtl = val;
      },
    },
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    plotName() {
      return this.plot.title;
    },
    plotPictures() {
      return this.plot.plot_pictures;
    },
    plotCategoryName() {
      const child_category_id = this.plot.child_category.id;
      return PLOT_CHILD_CATEGORY.properties[child_category_id].label;
    },
    plotComment() {
      return this.plot.detail.comment;
    },
    plotRegistrant() {
      if (this.plot.enterprise_public) {
        let enterpriseName = this.plot.enterprise_public.data.name || "未登録";
        return `${enterpriseName} (法人)`;
      } else if (this.plot.user_public) {
        let nickname =
          this.plot.user_public.data.nickname || "ニックネーム未登録";
        return `${nickname} (一般)`;
      } else {
        return "";
      }
    },
    plotStartDate() {
      return this.plot.detail.start_date;
    },
    plotEndDate() {
      return this.plot.detail.end_date;
    },
    plotInstaller() {
      return this.plot.detail.installer;
    },
    plotPhoneNumber() {
      return this.plot.detail.phone_number;
    },
    isConstruction() {
      return this.plot.child_category.id == PLOT_CHILD_CATEGORY.CONSTRUCTION;
    },
    isFreeAccount() {
      return this.$store.state.isFree === true;
    },
  },
  watch: {
    plot(newVal) {
      if (newVal) {
        this.SET_SELECTED_FIXED_POINT_CAMERA(null);
        this.plotIcon = require("@/assets/images/plot/" +
          PLOT_CHILD_CATEGORY.properties[this.plot.child_category.id].img +
          ".png");
        this.$vs.loading.close(
          "#sidebar-plot-detail-wrapper.vs-con-loading__container > .con-vs-loading",
        );
        this.$nextTick(() => {
          this.calcPlotDetailLowerBodyHeight();
        });
      } else {
        this.$vs.loading({
          container: "#sidebar-plot-detail-wrapper.vs-con-loading__container",
        });
      }
    },
  },
  methods: {
    ...mapMutations(["SET_SELECTED_FIXED_POINT_CAMERA"]),
    ...mapActions(["cleanUpPlotDetail"]),
    onPlotEdit() {
      this.$router.push({
        name: "enterprise-plot-edit",
        params: { id: this.plot.id, fromLiveMap: true },
      });
    },
    calcPlotDetailLowerBodyHeight() {
      const detailAreaEl = document.getElementById(
        "sidebar-plot-detail-wrapper",
      );
      const upperBodyEl = document.getElementById(
        "sidebar-plot-detail-upper-body",
      );
      const footerEl = document.getElementById("sidebar-plot-detail-footer");
      const lowerBodyHeight =
        detailAreaEl && upperBodyEl && footerEl
          ? detailAreaEl.getBoundingClientRect().height -
            upperBodyEl.getBoundingClientRect().height -
            footerEl.getBoundingClientRect().height
          : 300;
      const topBottomMargin = "40px";
      this.plotDetailLowerBodyHeight = `calc( ${lowerBodyHeight}px - ${topBottomMargin} )`;
    },
    /**
     * コメントのHTMLリプレイス
     * ・改行
     * ・URL
     */
    replaceComment(comment) {
      const replaced = comment
        .replace(
          /(https?:\/\/[^\s]*)/g,
          '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>',
        )
        .replace(/\n/g, "<br/>");
      return replaced;
    },
  },
  async mounted() {
    this.$vs.loading({
      container: "#sidebar-plot-detail-wrapper.vs-con-loading__container",
    });
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
#sidebar-plot-detail {
  .swiper-button-prev,
  .swiper-button-next {
    filter: drop-shadow(0px 2px 3px black);
    height: 2rem;
    top: 55%;
  }
  /* プロットのコメントのCSS */
  .plot-comment {
    line-height: 1.4rem;
    // URLが枠からはみ出ることがあるため折り返す
    word-wrap: break-word;
  }
}
.sidebar-plot-detail-loading__container {
  position: relative;
  width: 100%;
  height: 100%;
}

.sidebar-plot-detail-scroll-area {
  position: relative;
  margin: auto;
  width: 250px;
  pointer-events: auto;
}

.sidebar-plot-detail__container {
  pointer-events: auto;
}

.feather-icon-color {
  color: #1e1e1e;
}
#sidebar-plot-detail-wrapper {
  max-width: 260px;
  max-height: 650px;
  width: 100%;
  height: 100%;
}
</style>
